export default __webpack_public_path__ + "static/media/modal_cross_icon.a766b293.svg";